import { Button, FormControl, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router';
import {
  DEVICE_STATUS_FILTER,
  PAGE_SIZE_LIST,
  SERVICE_SUB_FILTER
} from '../constant/config';
import { useQuery } from '../hooks/useQuery';
import { _convertObjectToQuery } from '../utils/apiService';
import { useSelector } from 'react-redux';

const FilterBox = ({ listAgencies, searchRef, hasManagePermission, isAdmin }) => {
  const navigate = useNavigate();
  const queryParams = useQuery();

  const getDefaultFiltersValue = searchParams => ({
    agency_id: searchParams.get('agency_id')
      ? Number(searchParams.get('agency_id'))
      : undefined,
    device_type_id: searchParams.get('device_type_id')
      ? Number(searchParams.get('device_type_id'))
      : undefined,
    status: searchParams.get('status') || undefined,
    sub: searchParams.get('sub') || undefined
  });

  const listDeviceType = useSelector(
    state => state.deviceTypeSlice.listDeviceType
  );

  const deviceType = useMemo(
    () => [
      ...listDeviceType.map(type => ({
        id: type.id,
        name: type.name
      }))
    ],
    [listDeviceType]
  );

  const [query, setQuery] = useState(getDefaultFiltersValue(queryParams));

  useEffect(() => {
    setQuery(getDefaultFiltersValue(queryParams));
  }, [queryParams]);

  const handleChange = (e, value, type) => {
    if (type === 'agency_type') {
      const queryValue = Object.assign({}, query, {
        agency_id: Number(value.id)
      });
      setQuery(queryValue);
      applyFilterWithPageReset(queryValue);
    }
    if (type === 'device_type') {
      const queryValue = Object.assign({}, query, {
        device_type_id: Number(value.id)
      });
      setQuery(queryValue);
      applyFilterWithPageReset(queryValue);
    }
    if (type === 'status_type') {
      const queryValue = Object.assign({}, query, {
        status: value.value
      });
      setQuery(queryValue);
      applyFilterWithPageReset(queryValue);
    }
    if (type === 'sub_type') {
      const queryValue = Object.assign({}, query, {
        sub: value.value
      });
      setQuery(queryValue);
      applyFilterWithPageReset(queryValue);
    }
  };

  const applyFilterWithPageReset = filterQuery => {
    const queryWithPage = {
      ...filterQuery,
      page: 1,
      page_size: PAGE_SIZE_LIST
    };
    const queryString = _convertObjectToQuery(queryWithPage);
    navigate(`/app/manage/devices?${queryString}`);
  };

  const handleFilter = () => {
    if (query) {
      const queryWithPage = {
        ...query,
        page: 1,
        page_size: PAGE_SIZE_LIST
      };
      const queryString = _convertObjectToQuery(queryWithPage);
      navigate(`/app/manage/devices?${queryString}`);
      searchRef(queryWithPage);
    }
  };

  const handleResetFilter = () => {
    setQuery({
      agency_id: undefined,
      device_type_id: undefined,
      status: undefined,
      sub: undefined
    });
    navigate('/app/manage/devices');
    searchRef({
      agency_id: undefined,
      device_type_id: undefined,
      status: undefined,
      sub: undefined,
      page: 1,
      page_size: PAGE_SIZE_LIST
    });
  };

  return (
    <div className="py-3 px-4">
      <div className="row text-left title-filter mb-3">Bộ lọc</div>
      {hasManagePermission && (
        <div className="row justify-content-center mb-2">
          <FormControl className="filter-item" size="small" variant="outlined">
            <span className="mb-1 label-input-filter"> Đại lý </span>
            <Autocomplete
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              size="small"
              options={listAgencies || []}
              getOptionLabel={option => option.name}
              value={
                (listAgencies || []).find(
                  option => option.id === query.agency_id
                ) || null
              }
              onChange={(e, value) => handleChange(e, value, 'agency_type')}
              disableClearable
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Chọn đại lý"
                  name="agency_id"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '15px',
                      padding: '0 8px',
                      height: '40px'
                    }
                  }}
                />
              )}
            />
          </FormControl>
        </div>
      )}
      <div className="row justify-content-center mb-2">
        <FormControl className="filter-item" size="small" variant="outlined">
          <span className="mb-1 label-input-filter"> Mã thiết bị </span>
          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={deviceType || []}
            getOptionLabel={option => option.name}
            value={
              (deviceType || []).find(
                option => option.id === query.device_type_id
              ) || null
            }
            onChange={(e, value) => handleChange(e, value, 'device_type')}
            disableClearable
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Chọn mã thiết bị"
                name="device_type_id"
                InputProps={{
                  ...params.InputProps,
                  style: {
                    fontSize: '15px',
                    padding: '0 8px',
                    height: '40px'
                  }
                }}
              />
            )}
          />
        </FormControl>
      </div>

      <div className="row justify-content-center mb-2">
        <FormControl className="filter-item" size="small" variant="outlined">
          <span className="mb-1 label-input-filter"> Trạng thái </span>
          <Autocomplete
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            size="small"
            options={DEVICE_STATUS_FILTER || []}
            getOptionLabel={option => option.name}
            value={
              (DEVICE_STATUS_FILTER || []).find(
                option => option.value === query.status
              ) || null
            }
            onChange={(e, value) => handleChange(e, value, 'status_type')}
            disableClearable
            fullWidth={true}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Chọn trạng thái"
                name="device_type_id"
                InputProps={{
                  ...params.InputProps,
                  style: {
                    fontSize: '15px',
                    padding: '0 8px',
                    height: '40px'
                  }
                }}
              />
            )}
          />
        </FormControl>
      </div>

      {isAdmin && (
        <div className="row justify-content-center mb-2">
          <FormControl className="filter-item" size="small" variant="outlined">
            <span className="mb-1 label-input-filter"> Dịch vụ </span>
            <Autocomplete
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              size="small"
              options={SERVICE_SUB_FILTER || []}
              getOptionLabel={option => option.name}
              value={
                (SERVICE_SUB_FILTER || []).find(
                  option => option.value === query.sub
                ) || null
              }
              onChange={(e, value) => handleChange(e, value, 'sub_type')}
              disableClearable
              fullWidth={true}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Chọn số ngày còn lại"
                  name="sub"
                  InputProps={{
                    ...params.InputProps,
                    style: {
                      fontSize: '15px',
                      padding: '0 8px',
                      height: '40px'
                    }
                  }}
                />
              )}
            />
          </FormControl>
        </div>
      )}
      <div className="row mt-4">
        <div className="col-6">
          <Button
            className="btn-filter btn-plain"
            variant="contained"
            onClick={handleResetFilter}
          >
            Xóa bộ lọc
          </Button>
        </div>

        <div className="col-6">
          <Button
            className="btn-filter"
            color="primary"
            variant="contained"
            onClick={handleFilter}
          >
            Áp dụng
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterBox;
